import { strings as errorStrings } from '@components/ErrorComponent/strings';

const strings = {
  errorBanner: {
    title: 'Please fill out the required fields and try again:',
  },
  labels: {
    customerType: 'Customer Type',
    locationName: 'Location Name',
    customerName: 'Customer Name',
    residential: 'Residential',
    commercial: 'Commercial',
    customerPayeeOption: 'The Customer is the same as the Tenant',
    billingCustomerPayeeOption: 'The Customer is different from the Tenant',
  },
  headlines: {
    locationName: 'Where will the service be performed?',
    payee: 'Who will pay for the job?',
  },
  errors: {
    name: 'Enter a name',
    locationName: 'Enter a location name',
  },
  placeholders: {
    locationName: 'Name of tenant or location',
    billingName: 'Name of billing customer',
    payee: 'Who will pay?',
  },
  successToast: {
    title: 'Customer Created',
  },
  errorToast: {
    title: 'Unable to Create Customer',
    message: errorStrings.retryMessage,
  },
} as const;

export default strings;
